import { dataQuestionComment } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQuestionComment = /*#__PURE__*/createIcon(dataQuestionComment)
export default IconQuestionComment
